function _jade_template_fn(locals) {
  locals = locals || {};;;
  var result_of_with = (function($attr, $component, $helpers, Array, JSON, Object, String, cursorOnGripper, draggingLiteralIdx, newCohortsQBEnabled, stagedCohort) {
    var h = require("panel").h;
    var jade_mixins = {},
      $mixins = jade_mixins;
    jade_mixins['pane-base'] = function({
      updateSizeOnPostpatch
    } = {
      updateSizeOnPostpatch: true
    }) {
      var block = (this && this.block),
        attributes = (this && this.attributes) || {};

      return (function() {
        var __jade_nodes = [];
        const postpatch = updateSizeOnPostpatch ? $helpers.updateRenderedSize : () => null;;
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": {
            'builder-pane-base': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("div", {
            "hook": {
              insert: $helpers.updateRenderedSizeOnNextFrame,
              postpatch,
            },
            "class": {
              'builder-pane-container': true
            },
          }));
          __jade_nodes = __jade_nodes.concat(block && block());;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this);
    };

    jade_mixins['pane-title'] = function(title, options) {
      var block = (this && this.block),
        attributes = (this && this.attributes) || {};

      return (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": {
            'builder-pane-title': true
          },
        }, (function() {
          var __jade_nodes = [];
          options = options || {};
          __jade_nodes = __jade_nodes.concat((options.upsell) ? ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'builder-pane-upsell-header': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("svg-icon", {
                "attrs": __vjadeStringifyAttrsIfObj({
                  icon: 'lightning-bolt'
                }),
              }));
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": {
                  'builder-pane-upsell-text': true
                },
              }, [__vjadeSafeCode(title)]));
              __jade_nodes = __jade_nodes.concat(h("a", {
                "attrs": __vjadeStringifyAttrsIfObj({
                  href: '/pricing',
                  target: '_blank'
                }),
                "class": {
                  'builder-pane-upsell-text': true,
                  'builder-pane-upgrade-link': true
                },
              }, [__vjadeSafeCode(options.upsellLinkText)]));;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this)) : ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat((title) ? ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("div", {
                "attrs": __vjadeStringifyAttrsIfObj({
                  title
                }),
                "class": {
                  'builder-pane-title-label': true
                },
              }, [__vjadeSafeCode(title)]));;
              return __jade_nodes
            }).call(this)) : undefined);;
            return __jade_nodes
          }).call(this)));
          __jade_nodes = __jade_nodes.concat(block && block());
          __jade_nodes = __jade_nodes.concat((options.backButton && $helpers.numPanes() > 1) ? ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", {
              "on": {
                click: $helpers.clickedBackButton
              },
              "class": {
                'builder-pane-title-button': true,
                'builder-pane-back-button': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("svg-icon", {
                "attrs": __vjadeStringifyAttrsIfObj({
                  icon: 'caret-left'
                }),
              }));;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this)) : undefined);
          __jade_nodes = __jade_nodes.concat((options.closeButton) ? ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", {
              "on": {
                click: $helpers.clickedCloseButton
              },
              "class": {
                'builder-pane-title-button': true,
                'builder-pane-close-button': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("svg-icon", {
                "attrs": __vjadeStringifyAttrsIfObj({
                  icon: 'x'
                }),
              }));;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this)) : undefined);;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this);
    };

    jade_mixins['highlight-matches'] = function(matches) {
      var block = (this && this.block),
        attributes = (this && this.attributes) || {};

      return (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat((function() {
          var $$obj = (matches);
          var $$eachNodes;
          var $$iterated = false;
          if (Array.isArray($$obj)) {
            $$eachNodes = $$obj.reduce(function($$eachNodes, substr, si) {
              $$iterated = true;
              return $$eachNodes.concat((function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("span", {
                  "class": Object.assign({}, {
                    'builder-pane-matches-search': !(si % 2)
                  }, {
                    'builder-pane-substr': true
                  }),
                }, [__vjadeSafeCode(substr)]));;
                return __jade_nodes
              }).call(this));
            }, []);
          } else {
            $$eachNodes = [];
            for (var $$objKey in $$obj) {
              (function() {
                var si = $$objKey;
                if ($$obj.hasOwnProperty(si)) {
                  $$iterated = true;
                  var substr = $$obj[si];
                  $$eachNodes = $$eachNodes.concat((function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat(h("span", {
                      "class": Object.assign({}, {
                        'builder-pane-matches-search': !(si % 2)
                      }, {
                        'builder-pane-substr': true
                      }),
                    }, [__vjadeSafeCode(substr)]));;
                    return __jade_nodes
                  }).call(this));
                }
              })();
            }
          }

          return $$eachNodes;
        })());;
        return __jade_nodes
      }).call(this);
    };

    jade_mixins['screen-option'] = function(label, options) {
      var block = (this && this.block),
        attributes = (this && this.attributes) || {};

      return (function() {
        var __jade_nodes = [];
        options = options || {};
        __jade_nodes = __jade_nodes.concat((!options.noIcon) ? ((function() {
          var __jade_nodes = [];
          const icon = options.icon;
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'builder-pane-option-icon': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("svg-icon", {
              "attrs": __vjadeStringifyAttrsIfObj({
                icon,
                empty: !icon
              }),
            }));;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this)) : undefined);
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": {
            'builder-pane-option-label': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat((options.matches) ? ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(jade_mixins['highlight-matches'].call(this, options.matches));;
            return __jade_nodes
          }).call(this)) : ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'builder-pane-label': true
              },
            }, [__vjadeSafeCode(label)]));;
            return __jade_nodes
          }).call(this)));
          __jade_nodes = __jade_nodes.concat((options.description) ? ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'builder-pane-description': true
              },
            }, [__vjadeSafeCode(options.description)]));;
            return __jade_nodes
          }).call(this)) : undefined);;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this);
    };

    jade_mixins['small-caret-icon'] = function(options) {
      var block = (this && this.block),
        attributes = (this && this.attributes) || {};

      return (function() {
        var __jade_nodes = [];
        options = options || {};
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": {
            'builder-pane-caret-icon': true,
            'builder-pane-small-caret': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("svg-icon", {
            "attrs": __vjadeStringifyAttrsIfObj({
              icon: `caret-${options.direction || 'right'}`
            }),
          }));;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this);
    };

    jade_mixins['pane-loader'] = function() {
      var block = (this && this.block),
        attributes = (this && this.attributes) || {};

      return (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": {
            'builder-pane-loading': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("mp-spinner"));;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this);
    };

    var __vjadeStringifyAttrsIfObj = function(attrs) {
      if (typeof attrs !== 'object') return attrs;
      const copy = {};
      for (const [k, v] of Object.entries(attrs)) {
        copy[k] = typeof attrs[k] === 'object' ? JSON.stringify(v) : v;
      }
      return copy;
    }

    var __vjadeSafeCode = function(code) {
      return code || String(code);
    };
    const literals = stagedCohort.literals;
    const numLiterals = literals.length;
    return {
      value: (h("div", {
        "on": {
          dragend: $helpers.onLiteralDragEnd,
          dragover: $helpers.onBuilderDragOver,
          drop: $helpers.onLiteralDrop,
        },
        "class": {
          'cohorts-builder-body': true
        },
      }, (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat((numLiterals === 0 || !$helpers.doStoresHaveValue()) ? ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(jade_mixins['pane-loader'].call(this));;
          return __jade_nodes
        }).call(this)) : ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(($attr(`disabled`)) ? ((function() {
            var __jade_nodes = []; /*  Prevent click actions from going through */
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'cohorts-disabled-overlay': true
              },
            }));;
            return __jade_nodes
          }).call(this)) : undefined);
          __jade_nodes = __jade_nodes.concat(($helpers.hasNewCohortsQB()) ? ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("mp-toggle", {
              "attrs": __vjadeStringifyAttrsIfObj({
                theme: `segmented-controller`,
                selected: newCohortsQBEnabled ? `new_qb` : `legacy_qb`,
                options: $helpers.getQBToggleOptions(),
              }),
              "on": {
                select: $helpers.handleQBToggleSelect,
              },
            }));;
            return __jade_nodes
          }).call(this)) : undefined);
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'cohorts-header-section': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'cohorts-expression-label-container': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("mp-cohorts-expression-label", {
                "attrs": __vjadeStringifyAttrsIfObj({
                  expression: stagedCohort.expressionLabel
                }),
              }));;
              return __jade_nodes
            }).call(this).filter(Boolean)));
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'cohorts-header-reset-container': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat((!$attr(`hide-reset-button`)) ? ((function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("mp-tooltip", {
                  "attrs": __vjadeStringifyAttrsIfObj({
                    placement: `top`
                  }),
                }, (function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat("Reset cohort");;
                  return __jade_nodes
                }).call(this).filter(Boolean)));
                __jade_nodes = __jade_nodes.concat(h("mp-button", {
                  "attrs": __vjadeStringifyAttrsIfObj({
                    theme: `tertiary`,
                    disabled: $helpers.isDefaultStagedCohort(),
                    icon: `undo`,
                  }),
                  "on": {
                    click: $helpers.resetStagedCohort
                  },
                  "class": {
                    'cohorts-reset-btn': true
                  },
                }));;
                return __jade_nodes
              }).call(this)) : undefined);;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this).filter(Boolean)));
          __jade_nodes = __jade_nodes.concat((function() {
            var $$obj = (literals);
            var $$eachNodes;
            var $$iterated = false;
            if (Array.isArray($$obj)) {
              $$eachNodes = $$obj.reduce(function($$eachNodes, literal, literalIdx) {
                $$iterated = true;
                return $$eachNodes.concat((function() {
                  var __jade_nodes = [];
                  const draggable = !$helpers.isLiteralWithinAndBlock(literalIdx) && numLiterals >= 3;
                  const showAndOperator = $helpers.isLiteralWithinAndBlock(literalIdx) && !$helpers.isLiteralEndingAndBlock(literalIdx);
                  const showOrOperator = !showAndOperator && numLiterals > 1 && literalIdx !== (numLiterals - 1);
                  __jade_nodes = __jade_nodes.concat(h("div", {
                    "attrs": __vjadeStringifyAttrsIfObj({
                      draggable: String(draggable && cursorOnGripper),
                    }),
                    "on": {
                      dragover: $helpers.onLiteralDragOver,
                      dragstart: ev => $helpers.onLiteralDragStart(ev, literalIdx),
                    },
                    "class": Object.assign({}, {
                      'cohorts-literal-preview-operation': $helpers.isPreviewingOperation(literalIdx),
                      'cohorts-literal-within-and-block': $helpers.isLiteralWithinAndBlock(literalIdx),
                      'cohorts-literal-start-and-block': $helpers.isLiteralStartingAndBlock(literalIdx),
                      'cohorts-literal-middle-and-block': $helpers.isLiteralInMiddleAndBlock(literalIdx),
                      'cohorts-literal-end-and-block': $helpers.isLiteralEndingAndBlock(literalIdx),
                      'cohorts-literal-dragging': draggingLiteralIdx === literalIdx,
                    }, {
                      'cohorts-literal': true
                    }),
                  }, (function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat(($helpers.hasNewCohortsQB() && newCohortsQBEnabled) ? ((function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat(h("cohorts-literal-builder-new", {
                        "key": `literalIdx-${literalIdx}`,
                        "attrs": __vjadeStringifyAttrsIfObj({
                          'elref': `literalBuilder`,
                          "data-literal-idx": literalIdx,
                          "data-draggable": draggable,
                          disabled: $attr(`disabled`),
                          'data-group-id': $component.dataGroupId || ``,
                          "user-id": $attr(`user-id`),
                          'project-id': $component.projectId,
                          'workspace-id': $component.workspaceId,
                          "project-as-of-date": $attr(`project-as-of-date`),
                        }),
                        "dataset": {
                          literalIdx: literalIdx.toString()
                        },
                        "props": {
                          literal
                        },
                        "on": {
                          update: ev => $helpers.handleNewLiteralUpdate(ev, literalIdx)
                        },
                      }));;
                      return __jade_nodes
                    }).call(this)) : ((function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat($component.child(`cohorts-literal-builder`, {
                        attrs: {
                          'elref': `literalBuilder`,
                          'data-literal-idx': literalIdx,
                          'data-draggable': draggable,
                          'disabled': $attr(`disabled`),
                          'user-id': $attr(`user-id`),
                          'project-as-of-date': $attr(`project-as-of-date`)
                        }
                      }));;
                      return __jade_nodes
                    }).call(this)));
                    __jade_nodes = __jade_nodes.concat((showAndOperator) ? ((function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat(h("div", {
                        "on": {
                          click: ev => $helpers.toggleOperator(literalIdx),
                          mouseenter: ev => $helpers.previewOperation(literalIdx),
                          mouseleave: ev => $helpers.stopPreviewingOperation(literalIdx),
                        },
                        "class": {
                          'cohorts-operator': true,
                          'cohorts-and-operator-pill': true
                        },
                      }, (function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat(h("div", {
                          "class": {
                            'cohorts-operator-label': true
                          },
                        }, (function() {
                          var __jade_nodes = [];
                          __jade_nodes = __jade_nodes.concat("And");;
                          return __jade_nodes
                        }).call(this).filter(Boolean)));
                        __jade_nodes = __jade_nodes.concat(h("div", {
                          "class": {
                            'cohorts-operator-tooltip-wrapper': true
                          },
                        }, (function() {
                          var __jade_nodes = [];
                          __jade_nodes = __jade_nodes.concat(h("mp-tooltip", (function() {
                            var __jade_nodes = [];
                            __jade_nodes = __jade_nodes.concat("Ungroup (OR)");;
                            return __jade_nodes
                          }).call(this).filter(Boolean)));;
                          return __jade_nodes
                        }).call(this).filter(Boolean)));;
                        return __jade_nodes
                      }).call(this).filter(Boolean)));;
                      return __jade_nodes
                    }).call(this)) : undefined);;
                    return __jade_nodes
                  }).call(this).filter(Boolean)));
                  __jade_nodes = __jade_nodes.concat((showOrOperator) ? ((function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat(h("div", {
                      "on": {
                        click: ev => $helpers.toggleOperator(literalIdx),
                        mouseenter: ev => $helpers.previewOperation(literalIdx),
                        mouseleave: ev => $helpers.stopPreviewingOperation(),
                      },
                      "class": {
                        'cohorts-operator': true,
                        'cohorts-or-operator': true
                      },
                    }, (function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat(h("div", {
                        "class": {
                          'cohorts-operator-separator': true
                        },
                      }));
                      __jade_nodes = __jade_nodes.concat(h("div", {
                        "class": {
                          'cohorts-operator-label': true
                        },
                      }, (function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat("Or");
                        __jade_nodes = __jade_nodes.concat(h("div", {
                          "class": {
                            'cohorts-operator-tooltip-wrapper': true
                          },
                        }, (function() {
                          var __jade_nodes = [];
                          __jade_nodes = __jade_nodes.concat(h("mp-tooltip", (function() {
                            var __jade_nodes = [];
                            __jade_nodes = __jade_nodes.concat("Create group (AND)");;
                            return __jade_nodes
                          }).call(this).filter(Boolean)));;
                          return __jade_nodes
                        }).call(this).filter(Boolean)));;
                        return __jade_nodes
                      }).call(this).filter(Boolean)));;
                      return __jade_nodes
                    }).call(this).filter(Boolean)));;
                    return __jade_nodes
                  }).call(this)) : undefined);;
                  return __jade_nodes
                }).call(this));
              }, []);
            } else {
              $$eachNodes = [];
              for (var $$objKey in $$obj) {
                (function() {
                  var literalIdx = $$objKey;
                  if ($$obj.hasOwnProperty(literalIdx)) {
                    $$iterated = true;
                    var literal = $$obj[literalIdx];
                    $$eachNodes = $$eachNodes.concat((function() {
                      var __jade_nodes = [];
                      const draggable = !$helpers.isLiteralWithinAndBlock(literalIdx) && numLiterals >= 3;
                      const showAndOperator = $helpers.isLiteralWithinAndBlock(literalIdx) && !$helpers.isLiteralEndingAndBlock(literalIdx);
                      const showOrOperator = !showAndOperator && numLiterals > 1 && literalIdx !== (numLiterals - 1);
                      __jade_nodes = __jade_nodes.concat(h("div", {
                        "attrs": __vjadeStringifyAttrsIfObj({
                          draggable: String(draggable && cursorOnGripper),
                        }),
                        "on": {
                          dragover: $helpers.onLiteralDragOver,
                          dragstart: ev => $helpers.onLiteralDragStart(ev, literalIdx),
                        },
                        "class": Object.assign({}, {
                          'cohorts-literal-preview-operation': $helpers.isPreviewingOperation(literalIdx),
                          'cohorts-literal-within-and-block': $helpers.isLiteralWithinAndBlock(literalIdx),
                          'cohorts-literal-start-and-block': $helpers.isLiteralStartingAndBlock(literalIdx),
                          'cohorts-literal-middle-and-block': $helpers.isLiteralInMiddleAndBlock(literalIdx),
                          'cohorts-literal-end-and-block': $helpers.isLiteralEndingAndBlock(literalIdx),
                          'cohorts-literal-dragging': draggingLiteralIdx === literalIdx,
                        }, {
                          'cohorts-literal': true
                        }),
                      }, (function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat(($helpers.hasNewCohortsQB() && newCohortsQBEnabled) ? ((function() {
                          var __jade_nodes = [];
                          __jade_nodes = __jade_nodes.concat(h("cohorts-literal-builder-new", {
                            "key": `literalIdx-${literalIdx}`,
                            "attrs": __vjadeStringifyAttrsIfObj({
                              'elref': `literalBuilder`,
                              "data-literal-idx": literalIdx,
                              "data-draggable": draggable,
                              disabled: $attr(`disabled`),
                              'data-group-id': $component.dataGroupId || ``,
                              "user-id": $attr(`user-id`),
                              'project-id': $component.projectId,
                              'workspace-id': $component.workspaceId,
                              "project-as-of-date": $attr(`project-as-of-date`),
                            }),
                            "dataset": {
                              literalIdx: literalIdx.toString()
                            },
                            "props": {
                              literal
                            },
                            "on": {
                              update: ev => $helpers.handleNewLiteralUpdate(ev, literalIdx)
                            },
                          }));;
                          return __jade_nodes
                        }).call(this)) : ((function() {
                          var __jade_nodes = [];
                          __jade_nodes = __jade_nodes.concat($component.child(`cohorts-literal-builder`, {
                            attrs: {
                              'elref': `literalBuilder`,
                              'data-literal-idx': literalIdx,
                              'data-draggable': draggable,
                              'disabled': $attr(`disabled`),
                              'user-id': $attr(`user-id`),
                              'project-as-of-date': $attr(`project-as-of-date`)
                            }
                          }));;
                          return __jade_nodes
                        }).call(this)));
                        __jade_nodes = __jade_nodes.concat((showAndOperator) ? ((function() {
                          var __jade_nodes = [];
                          __jade_nodes = __jade_nodes.concat(h("div", {
                            "on": {
                              click: ev => $helpers.toggleOperator(literalIdx),
                              mouseenter: ev => $helpers.previewOperation(literalIdx),
                              mouseleave: ev => $helpers.stopPreviewingOperation(literalIdx),
                            },
                            "class": {
                              'cohorts-operator': true,
                              'cohorts-and-operator-pill': true
                            },
                          }, (function() {
                            var __jade_nodes = [];
                            __jade_nodes = __jade_nodes.concat(h("div", {
                              "class": {
                                'cohorts-operator-label': true
                              },
                            }, (function() {
                              var __jade_nodes = [];
                              __jade_nodes = __jade_nodes.concat("And");;
                              return __jade_nodes
                            }).call(this).filter(Boolean)));
                            __jade_nodes = __jade_nodes.concat(h("div", {
                              "class": {
                                'cohorts-operator-tooltip-wrapper': true
                              },
                            }, (function() {
                              var __jade_nodes = [];
                              __jade_nodes = __jade_nodes.concat(h("mp-tooltip", (function() {
                                var __jade_nodes = [];
                                __jade_nodes = __jade_nodes.concat("Ungroup (OR)");;
                                return __jade_nodes
                              }).call(this).filter(Boolean)));;
                              return __jade_nodes
                            }).call(this).filter(Boolean)));;
                            return __jade_nodes
                          }).call(this).filter(Boolean)));;
                          return __jade_nodes
                        }).call(this)) : undefined);;
                        return __jade_nodes
                      }).call(this).filter(Boolean)));
                      __jade_nodes = __jade_nodes.concat((showOrOperator) ? ((function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat(h("div", {
                          "on": {
                            click: ev => $helpers.toggleOperator(literalIdx),
                            mouseenter: ev => $helpers.previewOperation(literalIdx),
                            mouseleave: ev => $helpers.stopPreviewingOperation(),
                          },
                          "class": {
                            'cohorts-operator': true,
                            'cohorts-or-operator': true
                          },
                        }, (function() {
                          var __jade_nodes = [];
                          __jade_nodes = __jade_nodes.concat(h("div", {
                            "class": {
                              'cohorts-operator-separator': true
                            },
                          }));
                          __jade_nodes = __jade_nodes.concat(h("div", {
                            "class": {
                              'cohorts-operator-label': true
                            },
                          }, (function() {
                            var __jade_nodes = [];
                            __jade_nodes = __jade_nodes.concat("Or");
                            __jade_nodes = __jade_nodes.concat(h("div", {
                              "class": {
                                'cohorts-operator-tooltip-wrapper': true
                              },
                            }, (function() {
                              var __jade_nodes = [];
                              __jade_nodes = __jade_nodes.concat(h("mp-tooltip", (function() {
                                var __jade_nodes = [];
                                __jade_nodes = __jade_nodes.concat("Create group (AND)");;
                                return __jade_nodes
                              }).call(this).filter(Boolean)));;
                              return __jade_nodes
                            }).call(this).filter(Boolean)));;
                            return __jade_nodes
                          }).call(this).filter(Boolean)));;
                          return __jade_nodes
                        }).call(this).filter(Boolean)));;
                        return __jade_nodes
                      }).call(this)) : undefined);;
                      return __jade_nodes
                    }).call(this));
                  }
                })();
              }
            }

            return $$eachNodes;
          })());
          __jade_nodes = __jade_nodes.concat((!$attr(`disabled`)) ? ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'cohorts-add-literal-button-container': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("mp-button", {
                "attrs": __vjadeStringifyAttrsIfObj({
                  icon: `plus`,
                  theme: `tertiary`,
                  disabled: stagedCohort.numLiterals >= $helpers.MAX_LITERALS,
                }),
                "on": {
                  click: $helpers.addLiteral
                },
                "class": {
                  'cohorts-add-literal-button': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat("Group");;
                return __jade_nodes
              }).call(this).filter(Boolean)));;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this)) : undefined);;
          return __jade_nodes
        }).call(this)));;
        return __jade_nodes
      }).call(this).filter(Boolean)))
    };

  }.call(this, "$attr" in locals ? locals.$attr : typeof $attr !== "undefined" ? $attr : undefined, "$component" in locals ? locals.$component : typeof $component !== "undefined" ? $component : undefined, "$helpers" in locals ? locals.$helpers : typeof $helpers !== "undefined" ? $helpers : undefined, "Array" in locals ? locals.Array : typeof Array !== "undefined" ? Array : undefined, "JSON" in locals ? locals.JSON : typeof JSON !== "undefined" ? JSON : undefined, "Object" in locals ? locals.Object : typeof Object !== "undefined" ? Object : undefined, "String" in locals ? locals.String : typeof String !== "undefined" ? String : undefined, "cursorOnGripper" in locals ? locals.cursorOnGripper : typeof cursorOnGripper !== "undefined" ? cursorOnGripper : undefined, "draggingLiteralIdx" in locals ? locals.draggingLiteralIdx : typeof draggingLiteralIdx !== "undefined" ? draggingLiteralIdx : undefined, "newCohortsQBEnabled" in locals ? locals.newCohortsQBEnabled : typeof newCohortsQBEnabled !== "undefined" ? newCohortsQBEnabled : undefined, "stagedCohort" in locals ? locals.stagedCohort : typeof stagedCohort !== "undefined" ? stagedCohort : undefined));
  if (result_of_with) return result_of_with.value;
}
module.exports = _jade_template_fn;